/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventCameraSubjectSetFromJSON(json) {
    return StreemApiAnalyticEventCameraSubjectSetFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventCameraSubjectSetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
    };
}
export function StreemApiAnalyticEventCameraSubjectSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'subject': value.subject,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventCameraSubjectSetSubject;
(function (StreemApiAnalyticEventCameraSubjectSetSubject) {
    StreemApiAnalyticEventCameraSubjectSetSubject["PERSON"] = "CAMERA_SUBJECT_PERSON";
    StreemApiAnalyticEventCameraSubjectSetSubject["SCREEN"] = "CAMERA_SUBJECT_SCREEN";
    StreemApiAnalyticEventCameraSubjectSetSubject["WORLD"] = "CAMERA_SUBJECT_WORLD";
})(StreemApiAnalyticEventCameraSubjectSetSubject || (StreemApiAnalyticEventCameraSubjectSetSubject = {}));
//# sourceMappingURL=StreemApiAnalyticEventCameraSubjectSet.js.map